// src/components/dashboard/rent_to_own/rentToOwnPayment.js
// Приёмка 29.09 (решение USER «свой диалог договора»): сводка «к оплате по
// договору» для диалога приёма платежа. Платёж api раскладывает сам — по живым
// строкам графика с остатком, досрочный выкуп последним, затем по сроку и
// номеру (RentToOwn::Allocator). Сводка показывает то же в разрезе: аванс,
// комиссия за оформление, прочие строки со сроком по сегодня, ближайший платёж —
// и быстрые суммы для поля. Деньги — в копейках, наружу — рубли числом.
import { moneyToCents } from "@/components/dashboard/rent_to_own/rentToOwnFormat";

const DEAD = ["waived", "voided"];

function order(a, b) {
  const payoff = (a.kind === "early_payoff") - (b.kind === "early_payoff");
  if (payoff) return payoff;
  if (a.due_on !== b.due_on) return a.due_on < b.due_on ? -1 : 1;
  return a.number - b.number;
}

const toMoney = (cents) => cents / 100;

// `today` — "YYYY-MM-DD"; `due_on` строк приходит в том же виде.
export function paymentBreakdown(installments, today) {
  const ordered = (installments || [])
    .filter((row) => !DEAD.includes(row.coverage))
    .map((row) => Object.assign({}, row, { remaining: moneyToCents(row.amount) - moneyToCents(row.paid_amount) }))
    .filter((row) => row.remaining > 0)
    .sort(order);

  const sum = (rows) => rows.reduce((acc, row) => acc + row.remaining, 0);
  const advance = sum(ordered.filter((row) => row.kind === "advance"));
  const setupFee = sum(ordered.filter((row) => row.kind === "setup_fee"));
  const due = ordered.filter((row) => row.due_on <= today);
  const dueNow = sum(due);
  const scheduleRows = due.filter((row) => row.kind !== "advance" && row.kind !== "setup_fee");
  const scheduleDue = sum(scheduleRows);
  // Период наступивших строк — подпись «Наступило по графику, с … по …»: без него
  // сумма «по сегодня» читается как один платёж (приёмка 07.10).
  const dueDates = scheduleRows.map((row) => row.due_on).sort();
  const nextRow = ordered.find((row) => row.kind === "regular" && row.due_on > today) || null;

  const options = [];
  const push = (key, cents, extra = {}) => {
    if (cents > 0 && !options.some((option) => option.amount === toMoney(cents))) {
      options.push(Object.assign({ key, amount: toMoney(cents) }, extra));
    }
  };
  push("advance_fee", advance + setupFee);
  push("due_now", dueNow);
  if (nextRow) push("with_next", dueNow + nextRow.remaining, { due_on: nextRow.due_on });

  return {
    ordered,
    advance: toMoney(advance),
    setupFee: toMoney(setupFee),
    scheduleDue: toMoney(scheduleDue),
    scheduleDuePeriod: dueDates.length ? { from: dueDates[0], to: dueDates[dueDates.length - 1] } : null,
    dueNow: toMoney(dueNow),
    next: nextRow ? { number: nextRow.number, due_on: nextRow.due_on, amount: toMoney(nextRow.remaining) } : null,
    options,
  };
}
